import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ScenarioPublish } from "@/model";
import integrationRepository from "@/repository/integrationRepository";
import { integrationQueryKeys } from "./keys";


export const useUpdateWebchatTheme = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<ScenarioPublish, Error, FormData>({
        mutationKey: ['integration', 'webchat', 'update', scenarioId],
        mutationFn: async (formData: FormData) => {
            const { data } = await integrationRepository.updateWebchat(scenarioId, formData);
            return data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: integrationQueryKeys.read(scenarioId) });
        }
    });
};
